export function corrigirAcentuacao(texto) {

  const mapaSubstituicoes = {
    "Administra��o": "Administração",
    "Assist�ncia": "Assistência",
    "Finan�as": "Finanças",
    "Secret�ria": "Secretária",
    "Secret�rio": "Secretário",
    "Pol�ticas": "Políticas",
    "P�blicas": "Públicas",
    "Educa��o": "Educação",
    "Sa�de": "Saúde",
  };

  for (let padrao in mapaSubstituicoes) {
    const substituicao = mapaSubstituicoes[padrao];
    const regex = new RegExp(`\\b${padrao}\\w*`, 'gi');
    texto = texto.replace(regex, substituicao);
  }

  return texto;
}

export const categoryColors = {
  "Geral": "#000080",
  "Meio ambiente": "#28a745",
  "Moradia": "#795548",
  "Nota de pesar": "#343a40",
  "Política": "#007bff",
  "Programas sociais": "#17a2b8",
  "Agricultura": "#8bc34a",
  "Assistência Social": "#ff9800",
  "Cidadania": "#9c27b0",
  "Cultura": "#e91e63",
  "Educação": "#ffc107",
  "Esportes": "#4caf50",
  "Eventos": "#00bcd4",
  "Finanças": "#3f51b5",
  "Infraestrutura": "#607d8b",
  "Institucional": "#f44336",
  "Interesse público": "#009688",
  "Saúde": "#cddc39",
  "Segurança": "#ff5722",
  "Servidores": "#673ab7",
  "Trânsito": "#ffeb3b",
  "Turismo": "#2196f3",
  "Pesca": "#03a9f4",
};